import { isProduction } from 'config'

if (isProduction) {
  console.debug = () => {}
  console.log = () => {}
}
